import Vue from 'vue'
import VueRouter from "vue-router"
import index from "../pages/index.vue";
import withdrawalApplication from '../pages/withdrawal-application.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: 'index',
    component: index
  },
    {
    path: "/withdrawalApplication",
    name: 'withdrawalApplication',
    component: withdrawalApplication
  }
];

// 创建router实例
const router = new VueRouter({
  routes // (缩写) 相当于 routes: routes
});

export default router